export interface ThemeColors {
  primary: string;
  primaryHover: string;
  primaryActive: string;
  secondary: string;
  secondaryHover: string;
  buttonSecondaryBorder: string;
  buttonSecondaryBackground: string;
  buttonSecondaryBackgroundHover: string;
  buttonSecondaryText: string;
  placeholder: string;
  success: string;
  successHover: string;
  danger: string;
  dangerHover: string;
  warning: string;
  warningHover: string;
}

export interface ComponentSize {
  padding: string;
  fontSize: string;
  height: string;
}

export const themeColors: ThemeColors = {
  primary: '#00ab81',
  primaryHover: '#00896b',
  primaryActive: '#007a5e',
  secondary: '#6c757d',
  secondaryHover: '#5a6268',
  buttonSecondaryBorder: '#D5D7DA',
  buttonSecondaryBackground: '#ffffff',
  buttonSecondaryBackgroundHover: '#f8f9fa',
  buttonSecondaryText: '#414651',
  placeholder: '#717680',
  success: '#28a745',
  successHover: '#218838',
  danger: '#dc3545',
  dangerHover: '#c82333',
  warning: '#ffc107',
  warningHover: '#e0a800',
};

export const componentSize: ComponentSize = {
  padding: '8px 12px',
  fontSize: '14px',
  height: '40px',
};

export interface CommonStyles {
  label: {
    fontSize: string;
    fontWeight: string;
    color: string;
    marginBottom: string;
  };
  errorMessage: {
    marginTop: string;
    fontSize: string;
    color: string;
  };
}

export const commonStyles: CommonStyles = {
  label: {
    fontSize: '14px',
    fontWeight: '500',
    color: 'var(--color-text-secondary)',
    marginBottom: '6px',
  },
  errorMessage: {
    marginTop: '4px',
    fontSize: '12px',
    color: 'var(--color-danger)',
  },
};
